import { FLOW_API_CALL_FILE } from '../components/constants/api';
import {
  ApiFormDataBodyItem,
  ApiRequestBodyFormat,
  FormDataItemType,
} from '../typings/api';

export function deepCopyApiFormDataBodyArray(
  array: ApiFormDataBodyItem[]
): ApiFormDataBodyItem[] {
  return array.map((item) => ({
    ...item,
    value:
      typeof item.value === 'object' && item.value !== null
        ? [...item.value]
        : item.value,
  }));
}

export function fileListToArr(fileList: FileList | null): File[] {
  if (fileList === null) return [];
  const copiedFiles: File[] = Array.from(fileList).map(
    (file) => new File([file], file.name, { type: file.type })
  );

  return copiedFiles;
}

export function displayApiRequestBodyFormatName(
  format: ApiRequestBodyFormat
): string {
  return format.replace(/_/g, ' ');
}

interface Data {
  headers?: Record<string, string>;
  params?: Record<string, string>;
  pathParams?: Record<string, string>;
  body?: Record<string, string | number | boolean>;
  files?: Record<string, File[]>;
  [key: string]: string | undefined | Record<string, string | number | boolean> | {
      key: string;
      value: File[];
  }[] | Record<string, File[]> | undefined | number | boolean;
}

export function convertDataToFormData(data:Data) {
  const formData = new FormData();

  Object.keys(data).forEach(key => {
    if(key === 'headers' || key === 'params' || key === 'pathParams' || key === 'body'){
      formData.append(key,JSON.stringify(data[key]));
    }else if(key === 'files'){
      Object.keys(data[key] as Record<string, File[]> || {}).forEach(fileKey => {
        const files = (data[key] as Record<string, File[]>)[fileKey]
        files.forEach(file => {
          formData.append(fileKey,file);
        })
      })
    }else{
      if(data[key]) formData.append(key,data[key] as string);
    }
  })

  return formData;
}

export function formatBodyForFormDataItems(items: ApiFormDataBodyItem[]) {
  let body: Record<string, string> = {};

  for (let i = 0; i < items.length; i++) {
    const item = items[i];

    if (
      item.key === undefined ||
      item.value === undefined ||
      item.value === null
    )
      continue;

    if (item.type === FormDataItemType.FILE) {
      body[item.key] = FLOW_API_CALL_FILE;
    } else {
      body[item.key] = item.value as string;
    }
  }

  return body;
}
